// Code-action registry for navigational-features Phase 1.
//
// Pure data structure — Monaco-free so capability slices 10–14 can exercise
// fix factories under Vitest without `monaco-editor`'s DOM dependency. The
// Monaco adapter lives next door in `codeActionProvider.ts`.
//
// PRD: Ralph/NavigationalFeatures/PRD.md § Slice 4.

import type { CodeActionId, CodeActionRegistryEntry } from '../types';

export type CodeActionRegistry = {
  readonly register: (entry: CodeActionRegistryEntry) => void;
  readonly unregister: (id: CodeActionId) => void;
  readonly list: () => readonly CodeActionRegistryEntry[];
  readonly clear: () => void;
  readonly size: () => number;
};

/** Functional factory — each call yields an isolated registry instance. The
 *  Phase-1 wiring uses one registry per editor (created once, populated by
 *  capability slices 10–14 at module-init time). */
export function createCodeActionRegistry(): CodeActionRegistry {
  // Map keeps registration insertion order, which is also the order Monaco
  // surfaces the actions in the lightbulb menu.
  const entries = new Map<CodeActionId, CodeActionRegistryEntry>();

  return {
    register: (entry) => {
      entries.set(entry.id, entry);
    },
    unregister: (id) => {
      entries.delete(id);
    },
    list: () => Array.from(entries.values()),
    clear: () => entries.clear(),
    size: () => entries.size,
  };
}
